import { render, staticRenderFns } from "./TdOrgStructureTree.vue?vue&type=template&id=6b86c192&"
import script from "./TdOrgStructureTree.vue?vue&type=script&lang=js&"
export * from "./TdOrgStructureTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports